import { getEventBusIfDefined } from '@cian/event-bus';
import { Store } from 'redux';
import { IState } from '../../../../shared/store';
import { fetchNewbuildingMvk } from '../../../../shared/store/newbuilding_mvk';

export function createRenderCallback(store: Store<IState>) {
  const eventBus = getEventBusIfDefined();

  return () => {
    if (eventBus) {
      eventBus.emit('metrics-loader', {
        type: 'unlock-initialization',
      });
    }

    const { offerData } = store.getState();

    if (offerData.newObject && offerData.newObject.id) {
      store.dispatch(fetchNewbuildingMvk(offerData.newObject.id));
    }
  };
}
